define('home/views/CollapsingPostContentView',[
    'home/views/PostContentView',

    'home/mixins/withCollapsing',
], function (
    PostContentView,

    withCollapsing
) {
    'use strict';

    /**
     * The standard post content view that hides content beyond a
     * certain height behind a curtain.
     */
    var CollapsingPostContentView = PostContentView.extend({});

    withCollapsing.call(CollapsingPostContentView.prototype, {
        maxHeight: 115, // px
    });

    return CollapsingPostContentView;
});

